import React from 'react';
import { useHistory } from "react-router-dom";

import { Container } from './styles';

const CancelLink = () => {
    const history = useHistory();

    return (
        <Container type="button" onClick={() => history.goBack()}>
            Cancelar
        </Container>
    );
}

export default CancelLink;
